import utils from '@/utils/utils'
export default {
  renderPolyline(krp, row, index) {
    let name = `polyline_${row.id}`;
    const ext = typeof row.ext === 'string' && row.ext.length ? JSON.parse(row.ext) : row.ext;
    const krpano = krp.get('global');
    var hs = krpano.addhotspot(name);

    krp.call(`set(hotspot[${name}].borderwidth,${ext && ext.width ? ext.width : 2});`);
    krp.call(
      `set(hotspot[${name}].bordercolor,${
        ext && ext.color ? ext.color.replace('#', '0x') : '0xf00f00'
      });`
    );

    krp.call(`set(hotspot[${name}].polyline,true);`);
    krp.call(`set(hotspot[${name}].enabled,false);`);
    krp.call(`set(hotspot[${name}].handcursor,false);`);
    krp.call(`set(hotspot[${name}].renderer,css3d);`);
    row.pointData.forEach((point, pointIndex) => {
      krp.call(`set(hotspot[${name}].point[${pointIndex}].ath,${point.ath});`);
      krp.call(`set(hotspot[${name}].point[${pointIndex}].atv,${point.atv});`);
    });

    let timer = 0;

    if (ext.dotted === 1) {
      timer = setInterval(() => {
        if (hs.sprite && hs.sprite.parentElement) {
          const polyline = hs.sprite.parentElement.querySelectorAll('svg polyline');
          polyline[index].setAttribute('stroke-dasharray', '5,5');
          clearTimeout(timer);
        }
      }, 100);
    }

    if (ext && ext.isLine && ext.arrow === 1) {
      row.pointData.forEach((point, pointIndex) => {
        const nameArrow = `${name}_arrow_${pointIndex}`;
        const borderWidth = 4 + Number(ext.width);
        krp.call(`addhotspot(${nameArrow});`);
        krp.call(`set(hotspot[${nameArrow}].type,text);`);
        krp.call(`set(hotspot[${nameArrow}].html,'');`);
        krp.call(`set(hotspot[${nameArrow}].renderer,css3d);`);
        krp.call(`set(hotspot[${nameArrow}].edge,center);`);
        ext.rotate &&
          krp.call(`set(hotspot[${nameArrow}].rotate,${pointIndex * 180 + ext.rotate});`);
        krp.call(
          `set(hotspot[${nameArrow}].css,width:0;height:0;border-top:${borderWidth}px solid transparent;border-bottom:${borderWidth}px solid transparent;border-right:${borderWidth}px solid ${ext.color};`
        );
        krp.call(`set(hotspot[${nameArrow}].bgalpha,0);`);
        krp.call(`set(hotspot[${nameArrow}].ath,${point.ath});`);
        krp.call(`set(hotspot[${nameArrow}].atv,${point.atv});`);
      });
    }
  },

  rednerHotspot(krp, row) {
    let name = `hotspot_${row.id}`;
    let scale = row.isMobile ? row.mScale : row.scale;
    row.ext = row.ext || {};
    krp = krp.get('global');
    let spot = krp.addhotspot();
    spot.name = name;

    krp.call(`addhotspot(${name})`);
    krp.call(`set(hotspot[${name}].type,'image')`);
    krp.call(`set(hotspot[${name}].id,${row.id})`);
    krp.call(`set(hotspot[${name}].url,${row.imagePreview})`);
    krp.call(`set(hotspot[${name}].title,${row.title})`);
    krp.call(`set(hotspot[${name}].ath,${row.ath})`);
    krp.call(`set(hotspot[${name}].atv,${row.atv})`);
    krp.call(`set(hotspot[${name}].width,${row.width})`);
    krp.call(`set(hotspot[${name}].height,${row.height})`);
    krp.call(`set(hotspot[${name}].tx,${row.ext.tx || 0})`);
    krp.call(`set(hotspot[${name}].ty,${row.ext.ty || 0})`);
    krp.call(`set(hotspot[${name}].tz,${row.ext.tz || 0})`);
    krp.call(`set(hotspot[${name}].rx,${row.ext.rx || 0})`);
    krp.call(`set(hotspot[${name}].ry,${row.ext.rx || 0})`);
    krp.call(`set(hotspot[${name}].zorder,0)`);
    krp.call(`set(hotspot[${name}].bgcolor,${row.ext.bgcolor || ''})`);
    krp.call(`set(hotspot[${name}].bgroundedge,${row.ext.bgroundedge || ''})`);
    krp.call(`set(hotspot[${name}].rotationorder,${row.ext.rotationorder || 'xyz'})`);
    krp.call(`set(hotspot[${name}].distorted,${!!row.ext.distorted})`);
    krp.call(`set(hotspot[${name}].depth,${!isNaN(row.ext.depth) ? row.ext.depth : 1000})`);
    krp.call(`set(hotspot[${name}].scale,${scale || 1})`);
    krp.call(`set(hotspot[${name}].alpha,${row.opacity || 1})`);
    krp.call(`set(hotspot[${name}].onout,set(alpha,${row.opacity || 1})))`);
    row.imageType == 3 && krp.call(`set(hotspot[${name}].ondown,dragfloorspot)`);
    row.imageType == 3 && krp.call(`set(hotspot[${name}].onhover,overfloorspot)`);
    row.imageType == 3 && krp.call(`set(hotspot[${name}].onout,outfloorspot)`);
    row.imageType == 3 && krp.call(`set(hotspot[${name}].onclick,clickfloorspot(${row.id}))`);
    row.imageType == 1 &&
      krp.call(`set(hotspot[${name}].onloaded,do_crop_animation(${row.width},${row.height},40))`);

    krp.call(`set(hotspot[${name}].renderer,css3d)`);
  },

  rednerHotspotText(krp, row) {
    let name = `hotspot_${row.id}`;
    let fontSize = row.isMobile ? row.mFontSize : row.fontSize;
    row.ext = row.ext || {};
    krp.call(`addhotspot(${name})`);
    krp.call(`set(hotspot[${name}].type,'text')`);
    krp.call(`set(hotspot[${name}].id,${row.id})`);
    krp.call(`set(hotspot[${name}].html,${row.title})`);
    krp.call(`set(hotspot[${name}].ath,${row.ath})`);
    krp.call(`set(hotspot[${name}].atv,${row.atv})`);
    krp.call(`set(hotspot[${name}].zorder,0)`);
    krp.call(
      `set(hotspot[${name}].css,color:${row.ext.iconTxtColor};padding:${row.ext.iconTxtPadding}px;font-size:${fontSize}px)`
    );
    let bgcolor = row.ext.iconTxtBgColor ? row.ext.iconTxtBgColor.replace('#', '0x') : '';
    if(bgcolor){
      if(bgcolor.includes('rgba')){
        const color = utils.rgbaTo16(bgcolor);
        krp.call(`set(hotspot[${name}].bgcolor,${color.color})`);
        krp.call(`set(hotspot[${name}].bgalpha,${color.opacity})`);
      }else{
        krp.call(`set(hotspot[${name}].bgcolor,${bgcolor})`);
      }
    }else{
      krp.call(`set(hotspot[${name}].bgalpha,0)`);
    }

    krp.call(`set(hotspot[${name}].bgroundedge,${row.ext.iconTxtRadius || ''})`);
    krp.call(`set(hotspot[${name}].distorted,${!!row.ext.distorted})`);
    krp.call(`set(hotspot[${name}].ondown,draghotspot(${row.id}))`);
    krp.call(`set(hotspot[${name}].onover,overspot(${name}))`);
    krp.call(`set(hotspot[${name}].onout,outspot(${name}))`);
    // krp.call(`set(hotspot[${name}].renderer,css3d)`);
  },

  renderHotspotPlaceholder(krp, row) {
    let name = `hotspot_${row.id}`;
    let scale = row.isMobile ? row.mScale : row.scale;
    let namePlaceholder = name + '_placeholder';
    krp.call(`addhotspot(${namePlaceholder})`);
    krp.call(`set(hotspot[${namePlaceholder}].type,text)`);
    krp.call(`set(hotspot[${namePlaceholder}].ath,${row.ath})`);
    krp.call(`set(hotspot[${namePlaceholder}].atv,${row.atv})`);
    krp.call(`set(hotspot[${namePlaceholder}].width,${row.width * scale})`);
    krp.call(`set(hotspot[${namePlaceholder}].height,${row.height * scale})`);
    krp.call(`set(hotspot[${namePlaceholder}].zorder,1)`);
    krp.call(`set(hotspot[${namePlaceholder}].tx,${row.ext.tx || 0})`);
    krp.call(`set(hotspot[${namePlaceholder}].ty,${row.ext.ty || 0})`);
    krp.call(`set(hotspot[${namePlaceholder}].tz,${row.ext.tz || 0})`);
    krp.call(`set(hotspot[${namePlaceholder}].rx,${row.ext.rx || 0})`);
    krp.call(`set(hotspot[${namePlaceholder}].ry,${row.ext.ry || 0})`);
    krp.call(`set(hotspot[${namePlaceholder}].rotationorder,${row.ext.rotationorder || 'xyz'})`);
    krp.call(`set(hotspot[${namePlaceholder}].distorted,${!!row.ext.distorted})`);
    krp.call(
      `set(hotspot[${namePlaceholder}].depth,${!isNaN(row.ext.depth) ? row.ext.depth : 1000})`
    );
    krp.call(`set(hotspot[${namePlaceholder}].bgalpha,0)`);
    krp.call(`set(hotspot[${namePlaceholder}].ondown,draghotspot(${row.id}))`);
    krp.call(`set(hotspot[${namePlaceholder}].onover,overspot(${name}))`);
    krp.call(`set(hotspot[${namePlaceholder}].onout,outspot(${name}))`);

    // krp.call(`set(hotspot[${namePlaceholder}].renderer,css3d)`);
  },

  renderHotspotEdit(krp, row) {
    let name = `hotspot_${row.id}`;
    krp.call(`addlayer(${name}_edit)`);
    krp.call(`set(layer[${name}_edit].html,编辑)`);
    krp.call(`set(layer[${name}_edit].type,text)`);
    krp.call(`set(layer[${name}_edit].align,right)`);
    krp.call(`set(layer[${name}_edit].edge,left)`);
    krp.call(`set(layer[${name}_edit].visible,false)`);
    krp.call(`set(layer[${name}_edit].oy,-10)`);
    krp.call(
      `set(layer[${name}_edit].parent,hotspot[${
        row.imageType == 4 ? name : name + '_placeholder'
      }])`
    );
    krp.call(`layer[${name}_edit].loadstyle(hotspot_label_style)`);
    krp.call(`set(layer[${name}_edit].onclick,js(krpjs.editHotSpot(${row.id})))`);
  },

  renderHotspotDelete(krp, row) {
    let name = `hotspot_${row.id}`;
    krp.call(`addlayer(${name}_delete)`);
    krp.call(`set(layer[${name}_delete].html,删除)`);
    krp.call(`set(layer[${name}_delete].type,text)`);
    krp.call(`set(layer[${name}_delete].align,right)`);
    krp.call(`set(layer[${name}_delete].edge,left)`);
    krp.call(`set(layer[${name}_delete].visible,false)`);
    krp.call(`set(layer[${name}_delete].oy,10)`);
    krp.call(`layer[${name}_delete].loadstyle(hotspot_label_style)`);
    krp.call(
      `set(layer[${name}_delete].parent,hotspot[${
        row.imageType == 4 ? name : name + '_placeholder'
      }])`
    );
    krp.call(`set(layer[${name}_delete].onclick,js(krpjs.deleteHotSpot(${row.id})))`);
  },

  renderHotspotTitle(krp, row) {
    let name = `hotspot_${row.id}`;
    let fontSize = row.isMobile ? row.mFontSize : row.fontSize;
    let color = row.imageType == 5 ? '#449854' : '#fff';
    let shadow = row.imageType == 5 ? '1px 1px 1px #fff' : '2px 2px 4px #000';
    krp.call(`addlayer(${name}_title)`);
    krp.call(`set(layer[${name}_title].html,${row.title})`);
    krp.call(`set(layer[${name}_title].type,text)`);
    krp.call(`set(layer[${name}_title].align,top)`);
    krp.call(`set(layer[${name}_title].edge,bottom)`);
    krp.call(
      `set(layer[${name}_title].css,font-size:${fontSize}px; color:${color};text-shadow: ${shadow};)`
    );
    krp.call(`set(layer[${name}_title].bgalpha,0)`);
    krp.call(`set(layer[${name}_title].parent,hotspot[${name}_placeholder])`);
  },

  renderHotspotDesc(krp, row) {
    let name = `hotspot_${row.id}`;
    let nameDesc = `${name}_desc`;
    let html = row.ext.positionDesc;
    krp.call(`addlayer(${nameDesc})`);
    krp.call(`set(layer[${nameDesc}].html,${html})`);
    krp.call(`set(layer[${nameDesc}].type,text)`);
    krp.call(`set(layer[${nameDesc}].align,bottom)`);
    krp.call(`set(layer[${nameDesc}].edge,top)`);
    krp.call(`set(layer[${nameDesc}].width,200)`);
    krp.call(`set(layer[${nameDesc}].visible,true)`);
    krp.call(`set(layer[${nameDesc}].bgalpha,0)`);
    krp.call(`set(layer[${nameDesc}].oy,5)`);
    krp.call(
      `set(layer[${nameDesc}].css,background:rgba(255,255,255,0.7);padding:5px 10px;text-align:justify;)`
    );
    krp.call(`set(layer[${nameDesc}].parent,hotspot[${name}_placeholder])`);
  },

  removeHotspots(krp, arr) {
    arr.forEach((item) => {
      krp.call(`removehotspot(${item}))`);
      krp.call(`removelayer(${item}))`);
    });
  },
};
